import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const entrepreneurshipExercises: TopicExercises = {
  mcqs: [
    {
      id: "en1",
      difficulty: "easy",
      topic: "entrepreneurship",
      anchor: "what-is-entrepreneurship",
      question: "Entrepreneurship ka main goal kya hota hai?",
      options: ["Sirf copying", "Problem solve karke value create karna", "Notes yaad karna", "Internet speed barhana"],
      correctIndex: 1,
      explanation: "Entrepreneurship ka focus problem solve karna aur useful value create karna hota hai.",
    },
    {
      id: "en2",
      difficulty: "easy",
      topic: "design-thinking",
      anchor: "steps",
      question: "Design thinking ka pehla step kya hota hai?",
      options: ["Test", "Empathize", "Pitch", "Forecast"],
      correctIndex: 1,
      explanation: "Design thinking me sab se pehle user ko samjha jata hai.",
    },
    {
      id: "en3",
      difficulty: "medium",
      topic: "marketing",
      anchor: "audience-targeting",
      question: "Audience targeting ka simple matlab kya hai?",
      options: ["Har kisi ko same ad dikhana", "Right customer group ko focus karna", "Budget ignore karna", "Cost sirf barhana"],
      correctIndex: 1,
      explanation: "Marketing me sahi audience ko target karna zyada useful hota hai.",
    },
    {
      id: "en4",
      difficulty: "medium",
      topic: "business-plan",
      anchor: "core-parts",
      question: "Business plan me in me se kya include hota hai?",
      options: ["Idea aur strategy", "Sirf logo color", "Sirf internet package", "Sirf office chair"],
      correctIndex: 0,
      explanation: "Business plan idea, market, cost aur strategy ko combine karta hai.",
    },
    {
      id: "en5",
      difficulty: "easy",
      topic: "market-research",
      anchor: "customer-needs",
      question: "Market research ka basic focus kya hota hai?",
      options: ["Customer needs samajhna", "Exam dates change karna", "Code compile karna", "Password share karna"],
      correctIndex: 0,
      explanation: "Market research customer ki need aur trend ko samajhne ke liye hoti hai.",
    },
    {
      id: "en6",
      difficulty: "medium",
      topic: "finance",
      anchor: "profit-loss",
      question: "Profit ka simple matlab kya hai?",
      options: ["Kharcha income se zyada ho", "Income kharchay se zyada ho", "Budget zero ho", "Ad viral ho"],
      correctIndex: 1,
      explanation: "Profit tab hota hai jab income expenses se zyada ho.",
    },
    {
      id: "en7",
      difficulty: "easy",
      topic: "pitch",
      anchor: "storytelling",
      question: "Pitch me storytelling kyun useful hoti hai?",
      options: ["Idea ko clear aur memorable banati hai", "Budget hide karti hai", "Research avoid karti hai", "Customer confuse karti hai"],
      correctIndex: 0,
      explanation: "Good pitch clear story ki wajah se zyada samajh aati hai.",
    },
  ],
  short: [
    {
      id: "en-short-1",
      question: "Entrepreneurship kya hoti hai?",
      answer: "Entrepreneurship problem solve karke value create karne aur business idea ko practical form dene ka process hai.",
    },
    {
      id: "en-short-2",
      question: "Design thinking important kyun hai?",
      answer: "Design thinking user ki real need samajhne aur better solution banane me help karti hai.",
    },
    {
      id: "en-short-3",
      question: "Marketing me audience targeting kya hoti hai?",
      answer: "Audience targeting ka matlab right customer group ko focus karke message dena hota hai.",
    },
  ],
  long: [
    {
      id: "en-long-1",
      question: "Design thinking explain karo.",
      solution: "Design thinking human-centered approach hai jo user ko samajh kar problem solve karti hai.",
      steps: [
        "Empathize -> user ko samjho",
        "Define -> clear problem identify karo",
        "Ideate -> multiple ideas socho",
        "Test -> solution try karke improve karo",
      ],
    },
    {
      id: "en-long-2",
      question: "Business plan ke main parts explain karo.",
      solution: "Business plan idea ko practical shape dene ke liye roadmap hota hai.",
      steps: [
        "Business idea kya hai",
        "Target market kaun si hai",
        "Cost aur resources kya hain",
        "Strategy aur growth ka plan kya hai",
      ],
    },
    {
      id: "en-long-3",
      question: "Marketing strategy explain karo.",
      solution: "Marketing strategy product ko right audience tak pohanchane ka plan hota hai.",
      steps: [
        "Brand message clear karo",
        "Target audience define karo",
        "Suitable channel select karo",
        "Result dekh kar improve karo",
      ],
    },
  ],
};
